import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import * as Yup from 'yup';
import { Grid, makeStyles, Theme } from '@material-ui/core';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { FiArchive, FiCamera } from 'react-icons/fi';

import { useToast } from '../../../../../../../hooks/toast';
import { useGrupoPizza } from '../../../../../../../hooks/grupoPizza';

import InputLogged from '../../../../../../../components/InputLogged';

import no_image from '../../../../../../../assets/no_image.png';

import {
  ButtonAction,
  LabelWrapper,
  NewImg,
  TabWrapper,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';
import getValidationErrors from '../../../../../../../utils/getValidationErrors';

interface DetalhesRequest {
  descricao: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  img: {
    margin: 'auto',
  },
}));

const Detalhes: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const classes = useStyles();

  const { addToast } = useToast();
  const {
    grupoPizzaData,
    changeGrupoPizzaData,
    changeCurrentTabIndex,
    enableTamanhos,
    resetDrawer,
  } = useGrupoPizza();

  const [productImg, setProductImg] = useState<File | string>('');
  const [btnDisable, setBtnDisable] = useState(false);

  const handleProdutoImgChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.files) {
        setProductImg(event.target.files[0]);
      }
    },
    [],
  );

  const handleSubmit = useCallback(
    async (data: DetalhesRequest) => {
      setBtnDisable(true);

      formRef.current?.setErrors({});

      const schema = Yup.object().shape<DetalhesRequest>({
        descricao: Yup.string().required('O nome do grupo é obrigatório'),
      });

      try {
        await schema.validate(data, { abortEarly: false });

        changeGrupoPizzaData({
          descricao: data.descricao,
          image: productImg,
          pausar_venda: false,
        });

        setBtnDisable(false);

        enableTamanhos();
        changeCurrentTabIndex(1);
      } catch (err) {
        setBtnDisable(false);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          addToast({
            type: 'error',
            title: 'Preencha os dados corretamente pra continuar.',
          });
        }
      }
    },
    [productImg, addToast, changeCurrentTabIndex],
  );

  const handleImage = useCallback(() => {
    if (productImg) {
      if (typeof productImg === 'string') {
        return `${process.env.REACT_APP_SERVER_URL}/files/${productImg}`;
      }

      return URL.createObjectURL(productImg);
    }

    return no_image;
  }, [productImg]);

  useEffect(() => {
    setProductImg(grupoPizzaData?.image || '');
  }, [grupoPizzaData]);

  return (
    <TabWrapper>
      <Form ref={formRef} onSubmit={handleSubmit} initialData={grupoPizzaData}>
        <Grid container spacing={4}>
          <Grid item xs={3} className={classes.img}>
            <NewImg>
              <img src={handleImage()} alt="Grupo" />

              <label htmlFor="imagem">
                <FiCamera size={20} />
                <input
                  type="file"
                  id="imagem"
                  onChange={handleProdutoImgChange}
                />
              </label>
            </NewImg>
          </Grid>
          <Grid item xs={12}>
            <LabelWrapper>
              <span>Nome:</span>
            </LabelWrapper>

            <InputLogged
              name="descricao"
              placeholder="Nome do grupo"
              autoFocus
              icon={FiArchive}
            />
          </Grid>
          <Grid item xs={12}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={resetDrawer}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="submit"
                className="submit"
                id="submit_button"
                disabled={btnDisable}
              >
                Continuar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Detalhes;
